import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/', name: 'main', component: Main,
      children: [
        { // 初始登入頁
          path: '', name: 'login', component: () => import('./views/Login.vue'), },
        { // 信箱未認證
          path: '/login/auth', name: 'email_auth', component: () => import('./views/LoginAuth.vue'), },
        { // 忘記帳號頁
          path: '/forget_account', name: 'forget_account', component: () => import('./views/ForgetAccount.vue') },
        { // 忘記密碼頁
          path: '/forget_password', name: 'forget_password', component: () => import('./views/ForgetPassword.vue') },
        { // 註冊頁，
          path: '/register', name: 'register', component: () => import('./views/Register.vue') },
        { // 上聯會員服務使用條款，/register/contract
          path: '/register/contract', name: 'contract', component: () => import('./views/Contract.vue') },
        { // 註冊成功頁，/register/ok
          path: '/register/ok', name: 'register_ok', component: () => import('./views/RegisterOk.vue') },
      ]
    },
    // 第三方登入
    {
      path: '/social', name: 'social', component: () => import('./views/social/Social.vue'),
      children: [
        { // 第三方登入擷取資料頁，/social/link
          path: 'link', name: 'social_link', component: () => import('./views/social/SocialLink.vue'),
        },
        { // 第三方綁定 or 註冊
          path: 'register', name: 'social_register', component: () => import('./views/social/SocialRegister.vue'),
        },
      ],
    },
    // 會員頁
    {
      path: '/member', name: 'member', component: () => import('./views/member/Member.vue'),
      meta: { requireAuth: true },
      children: [
        { // 登入後的會員頁，/member/profile
          path: 'profile', name: 'profile', component: () => import('./views/member/Profile.vue'), meta: { requireAuth: true },
        },
        { // 修改會員資料頁 /member/profile_edit
          path: 'profile_edit', name: 'profile_edit', component: () => import('./views/member/MemberInfo.vue'), meta: { requireAuth: true },
        },
        {
          // 修改密碼頁
          // /member/password_edit
          path: 'password_edit',
          name: 'password_edit',
          component: () => import('./views/member/PasswordEdit.vue'),
          meta: { requireAuth: true },
        },
        {
          // 會員索票頁
          // /member/ticket
          path: 'ticket',
          name: 'ticket',
          component: () => import('./views/member/MemberTicket.vue'),
          meta: { requireAuth: true },
        },
      ]
    },
    // 錯誤頁，/404
    { path: '/404', name: '404', component: () => import('./views/Error404.vue') },
    // 將方上述網址全導至錯誤頁
    { path: '*', redirect: '/' },
    // 針對舊網址路徑做重導
    { path: '/#/home', redirect: 'member/profile'},
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})